import { Component, OnDestroy } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnDestroy {
  currentLanguage = '';

  links = [
    {
      title: 'top_navigation.nav_home',
      routeName: 'home',
    },
    {
      title: 'top_navigation.nav_about',
      routeName: 'about',
    },
    {
      title: 'top_navigation.nav_tokenomics',
      routeName: 'tokenomics',
    },
    {
      title: 'top_navigation.nav_howtobuy',
      routeName: 'how-to-buy',
    },
    {
      title: 'top_navigation.nav_roadmap',
      routeName: 'roadmap',
    },
    {
      title: 'top_navigation.nav_faq',
      routeName: 'faq',
    },
  ];

  items = [
    {
      title: 'footer_navigation.whitepaper',
      link: '/assets/documents/whitepaper.pdf',
    },
    {
      title: 'footer_navigation.documentation',
      link: 'https://qelt.ai/docs',
    },
    {
      title: 'footer_navigation.oracle',
      link: 'https://qxmp.ai/oracle',
    },
    {
      title: 'footer_navigation.on_chain_assets',
      link: 'https://qeltscan.ai/rwa',
    },
  ];

  social = [
    {
      img: 'assets/images/svg-icons/social-icons/telegram.svg',
      alt: 'Telegram',
      link: 'https://t.me/QXMPLabs',
    },
    {
      img: 'assets/images/svg-icons/social-icons/linkedin.svg',
      alt: 'LinkedIn',
      link: 'https://www.linkedin.com/company/qeltblockchain',
    },
    {
      img: 'assets/images/svg-icons/social-icons/twitter.svg',
      alt: 'Twitter',
      link: 'https://x.com/qeltblockchain',
    },
  ];

  docs = [
    {
      title: 'footer_navigation.privacy',
      link: 'https://qelt.ai/privacy',
    },
    {
      title: 'footer_navigation.terms',
      link: 'https://qelt.ai/terms',
    },
    {
      title: 'footer_navigation.cookies',
      link: 'https://qelt.ai/cookies',
    },
  ];

  subscription!: Subscription;

  constructor(private translate: TranslateService) {
    this.subscription = this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
      this.currentLanguage = params.lang;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
